module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      iframed: _vm.isInIframe
    }
  }, [_c('instamapsHeader', {
    attrs: {
      "isInIframe": _vm.isInIframe,
      "isUserLogged": _vm.isUserLogged,
      "logo": _vm.logo,
      "url": _vm.url,
      "mapName": _vm.mapName,
      "viewerParams": _vm.viewerParams,
      "contact": _vm.contact
    },
    on: {
      "langchanged": _vm.langChange,
      "mobileMenuPressed": _vm.showMobileMenu,
      "logout": _vm.userLogout,
      "toProfile": _vm.redirectProfile
    }
  }), _vm._v(" "), _c('instamapsMapViewer', {
    ref: "instamapsMapViewer",
    attrs: {
      "isInIframe": _vm.isInIframe
    },
    on: {
      "loading": function($event) {
        _vm.showLoader($event)
      },
      "loaded": _vm.hideLoader
    }
  }), _vm._v(" "), _c('instamapsFooter'), _vm._v(" "), _c('instamapsLoader', {
    attrs: {
      "show": _vm.isLoading,
      "title": _vm.loaderTitle,
      "message": _vm.loaderMessage,
      "isStatic": _vm.loaderIsStatic,
      "hasDismiss": _vm.loaderHasDismiss,
      "isError": _vm.loaderIsError
    },
    on: {
      "loaded": _vm.hideLoader
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f57fac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 130
// module chunks = 0